
import { PROMISE_RUN } from '../constants/promise.constant';

import defaultState from '../store/defaultState';
import {
  TEAM_LIST_GET,
  SERVICE_ENTRY_LIST_GET,
  USER_SIGN_IN,
  USER_GET,
  USER_SIGN_OUT,
  SERVICE_ENTRY_GET,
  API_DOC_LIST_GET,
  API_LIST_SEARCH,
  API_GET, API_DOC_GET
} from '../actions/app.constant';


export default (state = defaultState.app, action) => {
  if (action.type === PROMISE_RUN) {

    if (action.key === USER_SIGN_IN) {
      const result = action.payload.result;
      if (result) {
        localStorage.setItem('token', result.session.token)
        return {
          ...state,
          user: result.user,
        }
      }
    }

    if (action.key === USER_GET) {
      const result = action.payload.result;
      if (result) {
        return {
          ...state,
          user: result,
        }
      }
    }

    if (action.key === TEAM_LIST_GET) {
      const result = action.payload.result;
      if (result) {
        return {
          ...state,
          teams: result
        }
      }
    }


    // if (action.key === SERVICE_ENTRY_LIST_GET) {
    //   const result = action.payload.result;
    //   const teamId = action.teamId;
    //   console.log('teamId', teamId);
    //   if (result) {
    //     let teams = state.teams;
    //     let newTeams = teams.map(team => {
    //         if (team.id === teamId) {
    //           console.log('matched ', result)
    //           return {
    //             ...team,
    //             serviceEntries: result
    //           }
    //         } else {
    //           return team;
    //         }
    //     })

    //     return {
    //       ...state,
    //       teams: newTeams
    //     }
    //   }
    // }

    if (action.key === SERVICE_ENTRY_GET) {
      const result = action.payload.result;
      if (result) {
        return {
          ...state,
          serviceEntry: result
        }
      }
    }

    if (action.key === API_DOC_LIST_GET) {
      const result = action.payload.result;
      if (result) {
        return {
          ...state,
          serviceEntry: {
            ...state.serviceEntry,
            apidocs: result
          }
        }
      }
    }

    // if (action.key === API_LIST_SEARCH) {
    //   const result = action.payload.result;
    //   if(result) {
    //     return {
    //       ...state,
    //       apis: result
    //     }
    //   }
    // }

    if (action.key === API_GET) {
      const result = action.payload.result;
      if (result) {
        return {
          ...state,
          apiView: {
            ...state.apiView,
            api: result
          }
        }
      }
    }


    if (action.key === API_DOC_GET) {
      const result = action.payload.result;
      if (result) {
        return {
          ...state,
          apiDocView: {
            ...state.apiDocView,
            apidoc: result
          }
        }
      }
    }

  }

  if (action.type === USER_SIGN_OUT) {
    localStorage.removeItem('token')
    return {
      ...state,
      user: null
    }
  }

  if (action.type === USER_GET) {
    return {
      ...state,
      user: action.payload
    }
  }

    return state;
};
